import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';


export default function EmergencyContactStep({ formData, errors, onChange }) {
  const relationshipOptions = [
    { value: 'parent', label: 'Parent' },
    { value: 'spouse', label: 'Spouse' },
    { value: 'sibling', label: 'Sibling' },
    { value: 'guardian', label: 'Guardian' },
    { value: 'friend', label: 'Friend' },
    { value: 'relative', label: 'Relative' },
    { value: 'other', label: 'Other' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Emergency Contact</h2>
        <p className="text-gray-600">Provide details of someone we can contact in case of emergency</p>
        <div className="mt-4 p-4 bg-amber-50 border-l-4 border-amber-400 rounded">
          <div className="flex items-start gap-2">
            <Icon name="AlertTriangle" size={20} color="#F59E0B" className="flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-amber-800">Important Notice</p>
              <p className="text-xs text-amber-700 mt-1">
                Emergency contact phone number must be different from your phone, alternative phone, and WhatsApp number. 
                Using your own phone number as emergency contact is not permitted for security reasons.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Full Name */}
        <div className="md:col-span-2">
          <Input
            label="Full Name"
            name="emergencyContactName"
            value={formData?.emergencyContactName || ''}
            onChange={(e) => onChange('emergencyContactName', e?.target?.value)}
            error={errors?.emergencyContactName}
            placeholder="Enter emergency contact's full name"
            required
          />
        </div>

        {/* Relationship */}
        <div className="md:col-span-2">
          <Select
            label="Relationship"
            name="emergencyContactRelationship"
            value={formData?.emergencyContactRelationship || ''}
            onChange={(value) => onChange('emergencyContactRelationship', value)}
            error={errors?.emergencyContactRelationship}
            options={relationshipOptions}
            placeholder="Select relationship"
            required
          />
        </div>

        {/* Phone Number */}
        <div>
          <Input
            label="Phone Number"
            type="tel"
            name="emergencyContactPhone"
            value={formData?.emergencyContactPhone || ''}
            onChange={(e) => onChange('emergencyContactPhone', e?.target?.value)}
            error={errors?.emergencyContactPhone}
            placeholder="e.g., 08012345678"
            helperText="Must be different from your phone numbers"
            required
          />
        </div>

        {/* Alternative Phone (Optional) */}
        <div>
          <Input
            label="Alternative Phone"
            type="tel"
            name="emergencyContactAlternativePhone"
            value={formData?.emergencyContactAlternativePhone || ''}
            onChange={(e) => onChange('emergencyContactAlternativePhone', e?.target?.value)}
            placeholder="e.g., 08098765432"
            helperText="Optional secondary contact number"
          />
        </div>

        {/* Email (Optional) */}
        <div className="md:col-span-2">
          <Input
            label="Email Address"
            type="email"
            name="emergencyContactEmail"
            value={formData?.emergencyContactEmail || ''}
            onChange={(e) => onChange('emergencyContactEmail', e?.target?.value)}
            placeholder="contact@example.com"
            helperText="Optional - for additional contact method"
          />
        </div>

        {/* Address */}
        <div className="md:col-span-2">
          <Input
            label="Address"
            name="emergencyContactAddress"
            value={formData?.emergencyContactAddress || ''}
            onChange={(e) => onChange('emergencyContactAddress', e?.target?.value)}
            error={errors?.emergencyContactAddress}
            placeholder="Enter emergency contact's full address"
            helperText="Include street, city, and state"
            required
          />
        </div>
      </div>

      {/* Validation Warning */}
      {(formData?.emergencyContactPhone === formData?.phone || 
        formData?.emergencyContactPhone === formData?.alternativePhone ||
        formData?.emergencyContactPhone === formData?.whatsappNumber) && (
        <div className="p-4 bg-red-50 border-l-4 border-red-400 rounded">
          <div className="flex items-start gap-2">
            <Icon name="XCircle" size={20} color="#DC2626" className="flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-red-800">Invalid Emergency Contact</p>
              <p className="text-xs text-red-700 mt-1">
                The emergency contact phone number cannot be the same as your personal phone numbers. 
                Please provide a different contact person.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}